module.exports = __webpack_public_path__ + "static/media/close-icon.91979e51.svg";